/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_ResentInputs */

const en_password_reset_resent = /** @type {(inputs: Password_Reset_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We sent you a new link.`)
};

const es_password_reset_resent = /** @type {(inputs: Password_Reset_ResentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te enviamos un enlace nuevo.`)
};

/**
* | output |
* | --- |
* | "We sent you a new link." |
*
* @param {Password_Reset_ResentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_resent = /** @type {((inputs?: Password_Reset_ResentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_ResentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_resent(inputs)
	return en_password_reset_resent(inputs)
});